<script>
  import UploadCam from '@/assets/upload-cam.svg';
  import UploadModal from '@/components/Upload/Modal';

  export default {
    components: {
      UploadModal,
      UploadCam,
    },

    props: {
      title: {
        type: String,
        required: false,
      },

      webcam: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    data: () => ({
      dirty: false,
      show: false,
    }),

    methods: {
      open () {
        this.$refs.file.click();
      },

      upload (blob) {
        const file = blob || this.$refs.file.files[0];

        const reader = new FileReader();

        reader.onload = (event) => {
          this.dirty = true;
          this.show = false;

          this.$nextTick(() => {
            this.$refs.image.src = event.target.result;
          });
        };

        reader.readAsDataURL(file);
      },
    },
  };
</script>

<template>
  <div class="upload">
    <h3
      v-if="title"
      v-text="title"
      class="upload__title"
      >
    </h3>

    <div
      @click.prevent="open"
      class="upload__display"
      >

      <figure
        v-if="dirty"
        class="upload__image"
        >
        <img ref="image">
      </figure>

      <slot v-else />
    </div>

    <input
      type="file"
      ref="file"
      @change="upload()"
      class="upload__input"
      >

    <template v-if="webcam">
      <button
        @click="show = true"
        class="upload__action"
        >
        <UploadCam />
      </button>

      <transition name="fade">
        <UploadModal
          v-if="show"
          @image="upload"
          @close="show = false"
          />
      </transition>
    </template>
  </div>
</template>

<style lang="scss">
  .upload {
    display: flex;
    flex-direction: column;

    &__title {
      font-size: 20px;
      color: #b2b8c5;
      margin-left: 5px;
      margin-bottom: 12px;
    }

    &__display {
      width: 185px;
      height: 162px;
      display: flex;
      cursor: pointer;
      text-align: center;
      position: relative;
      border-radius: 6px;
      padding: 57px 60px;
      align-items: center;
      justify-content: center;
      background-color: #14162f;

      &:hover {
        background-color: #0f1127;
      }
    }

    &__image {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 0;
      display: flex;
      text-align: center;
      padding: 32px 24px;
      position: absolute;
      align-items: center;
      justify-content: center;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    &__action {
      opacity: .4;
      margin-top: 22px;

      &:hover {
        opacity: .8;
      }
    }

    &__input {
      opacity: 0;
      display: none;
      position: absolute;
    }
  }
</style>
